<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{ $t('product_types.product_types') }}</h2>
        <product-types-table-component/>
    </layout-authenticated>
</template>

<script>
import ProductTypesTableComponent from '@/components/admin/tables/ProductTypesTableComponent'
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Addresses',
    components: {LayoutAuthenticated, ProductTypesTableComponent},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('product_types.product_types'),
                    href: '/admin/product-types',
                    disabled: true
                }
            ];
        }
    }
}
</script>
